export const TOKEN = 'auth:token';

export const VISITANTES_STORAGE = {

  statusVisitantes: 'status-visitantes',
};

export const RECEBIMENTO_STORAGE = {
  createFrom: 'recebimento:create-from',
  createBefore: 'recebimento:create-before',
  page: 'recebimento:page',
  sort: 'recebimento:sort',
  search: 'recebimento:search',
  textofiltro: 'recebimento:textofiltro',
  parametro: 'recebimento:parametro',
  armazem: 'recebimento:armazem',
};

export const RECEBIMENTO_RESUMO_STORAGE = {
  createFrom: 'resumo:create-from',
  createBefore: 'resumo:create-before',
  page: 'resumo:page',
  sort: 'resumo:sort',
  search: 'resumo:search',

};

export const ESTOQUE_STORAGE = {
  createFrom: 'estoque:create-from',
  createBefore: 'estoque:create-before',
  page: 'estoque:page',
  sort: 'estoque:sort',
  search: 'estoque:search',

};

export const LOTES_STORAGE = {
  createFrom: 'lotes:create-from',
  createBefore: 'lotes:create-before',
  prefixo: 'lotes:prefixo',
  page: 'lotes:page',
  sort: 'lotes:sort',
  search: 'lotes:search',
  textofiltro: 'lotes:textofiltro',

};

export const PRODUCAO_STORAGE = {
  createFrom: 'producao:create-from',
  createBefore: 'producao:create-before',
  page: 'producao:page',
  sort: 'producao:sort',
  search: 'producao:search',
  fabrica: 'producao:fabrica',
};

export const APONTAMENTO_PESAGEM_STORAGE = {
  createFrom: 'apontamento_pesagem:create-from',
  createBefore: 'apontamento_pesagem:create-before',
  page: 'apontamento_pesagem:page',
  sort: 'apontamento_pesagem:sort',
  search: 'apontamento_pesagem:search',
  granulometria: 'apontamento_producao:granulometria',
  labelgranulometria: 'apontamento_producao:labelgranulometria',
  prefixo: 'apontamento_producao:prefixo',
};

export const FILA_STORAGE = {
  statusFila: 'status-fila',
  tipoFila: 'tipo-fila',
  interval: 'interval',
};

export const CONSULTA_STORAGE = {
  statusFila: 'status-fila',
  tipoFila: 'tipo-fila',
};

export const CADASTRO_STORAGE = {
  statusFila: 'status-fila',
  tipoFila: 'tipo-fila',
};

export const MODULOS_STORAGE = {
  modulos: 'permitidos',
};

export const USER_STORAGE = {
  userId: 'id-usuario',
  trocasenha: 'troca-senha',
  instrucoes: 'troca-senha-instrucoes',
};

export const A_PAGAR_STORAGE = {
  createFrom: 'apagar:create-from',
  createBefore: 'apagar:create-before',
  parametro: 'apagar:parametro',
  page: 'apagar:page',
  sort: 'apagar:sort',
  search: 'apagar:search',
  textofiltro: 'apagar:textofiltro',
};

export const A_RECEBER_STORAGE = {
  createFrom: 'areceber:create-from',
  createBefore: 'areceber:create-before',
  parametro: 'areceber:parametro',
  page: 'areceber:page',
  sort: 'areceber:sort',
  search: 'areceber:search',
  textofiltro: 'areceber:textofiltro',
};

export const IMG_CONTRATO_STORAGE = {
  numero: 'imgcontrato:numero',
  sufixo: 'imgcontrato:sufixo',
  page: 'imgcontrato:page',
};

export const FLUXO_DE_CAIXA_STORAGE = {
  createFrom: 'areceber:create-from',
  createBefore: 'areceber:create-before',
  page: 'areceber:page',
  sort: 'areceber:sort',
  search: 'areceber:search',
};

export const CONTRATO_EXPORTACAO = {
  createFrom: 'contrato-exportacao:create-from',
  createBefore: 'contrato-exportacao:create-before',
  parametro: 'contrato-exportacao:parametro',
  page: 'contrato-exportacao:page',
  sort: 'contrato-exportacao:sort',
  search: 'contrato-exportacao:search',
  textofiltro: 'contrato-exportacao:textofiltro',
};

export const CONTRATO_EXPORTACAO_INVOICE = {
  createFrom: 'contrato-exportacao-invoice:create-from',
  createBefore: 'contrato-exportacao-invoice:create-before',
  parametro: 'contrato-exportacao-invoice:parametro',
  page: 'contrato-exportacao-invoice:page',
  sort: 'contrato-exportacao-invoice:sort',
  search: 'contrato-exportacao-invoice:search',
  textofiltro: 'contrato-exportacao-invoice:textofiltro',
};

export const CONTRATO_CAMBIO = {
  createFrom: 'contrato-cambio:create-from',
  createBefore: 'contrato-cambio:create-before',
  parametro: 'contrato-cambio:parametro',
  page: 'contrato-cambio:page',
  sort: 'contrato-cambio:sort',
  search: 'contrato-cambio:search',
  textofiltro: 'contrato-cambio:textofiltro',
};

export const PESAGEM_STORAGE = {
  createFrom: 'pesagem:create-from',
  createBefore: 'pesagem:create-before',
  page: 'pesagem:page',
  sort: 'pesagem:sort',
  search: 'pesagem:search',
  textofiltropessoa: 'pesagem:textofiltropessoa',
  textofiltromotorista: 'pesagem:textofiltromotorista',
  pessoa: 'pesagem:pessoa',
  motorista: 'pesagem:motorista',
  tipo: 'pesagem:tipo',
  materiaprima: 'pesagem:materiaprima',
  situacao: 'pesagem:situacao',
};

export const CONTRATO_MP_STORAGE = {
  createFrom: 'contratomp:create-from',
  createBefore: 'contratomp:create-before',
  page: 'contratomp:page',
  sort: 'contratomp:sort',
  search: 'contratomp:search',
  safra: 'contratomp:safra',
};

export const CONTROLE_ARMAZENAMENTO_STORAGE = {
  createFrom: 'controlearmazenamento:create-from',
  createBefore: 'controlearmazenamento:create-before',
  page: 'controlearmazenamento:page',
  sort: 'controlearmazenamento:sort',
  search: 'controlearmazenamento:search',
  idlocal: 'controlearmazenamento:idlocal',
};
